export default {"src":"/_next/static/media/icon-back-dark.2fc535c2.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};